import * as React from 'react';

import { SimilarOffersContainer } from '../container';
import { Layout } from './components/Layout';

export enum EModelTypes {
  UserBased = 'userBased',
  ItemBased = 'itemBased',
  HistoryBased = 'historyBased',
}

export interface ISimilarOffersGroupsProps {
  itemBasedVisible: boolean;
  historyBasedVisible: boolean;
}

export const SimilarOffersGroups: React.FC<ISimilarOffersGroupsProps> = ({ itemBasedVisible, historyBasedVisible }) => {
  return (
    <div id="similarOffers">
      <Layout
        itemBased={
          itemBasedVisible && <SimilarOffersContainer key={EModelTypes.ItemBased} modelType={EModelTypes.ItemBased} />
        }
        userBased={<SimilarOffersContainer key={EModelTypes.UserBased} modelType={EModelTypes.UserBased} />}
        historyBased={
          historyBasedVisible && (
            <SimilarOffersContainer key={EModelTypes.HistoryBased} modelType={EModelTypes.HistoryBased} />
          )
        }
      />
    </div>
  );
};

SimilarOffersGroups.displayName = 'SimilarOffersGroups';
